export default __webpack_public_path__ + "static/home5-b788453deae8388d8474130e6f09af26.jpg";